import { useCarEBoxLocations } from 'entities/cars';
import { useCallback } from 'react';

export const useGetActiveStatus = () => {
  const carEBoxLocations = useCarEBoxLocations();

  return useCallback(
    (lichenPlate?: Nullable<string>) => {
      if (!carEBoxLocations || !lichenPlate) {
        return 0;
      }

      const findDevice = carEBoxLocations.find(({ autoNumber }) => autoNumber === lichenPlate);
      return findDevice?.status ?? 0;
    },
    [carEBoxLocations]
  );
};
